import apiClient from "../lib/apiClient";

export type PublicationRequestStatus = "PENDING" | "APPROVED" | "REJECTED";

export interface PublicationRequestDto {
  name: string;
  email: string;
  commune?: string;
  description?: string;
  proposedDate?: string;
}

export interface PublicationRequestResponse {
  id: string;
  name: string;
  email: string;
  commune?: string;
  description?: string;
  proposedDate?: string;
  status: PublicationRequestStatus;
  createdParcoursId?: string;
  createdMemberUserId?: string;
  createdAt: string;
  updatedAt: string;
}

export async function submitPublicationRequest(dto: PublicationRequestDto) {
  const { data } = await apiClient.post<PublicationRequestResponse>("/publication-request", dto);
  return data;
}

export async function listPublicationRequests(status?: PublicationRequestStatus) {
  const { data } = await apiClient.get<PublicationRequestResponse[]>("/publication-request", {
    params: status ? { status } : undefined,
  });
  return data;
}

export async function approvePublicationRequest(id: string) {
  const { data } = await apiClient.put<PublicationRequestResponse>(`/publication-request/${id}/approve`);
  return data;
}

export async function rejectPublicationRequest(id: string) {
  const { data } = await apiClient.put<PublicationRequestResponse>(`/publication-request/${id}/reject`);
  return data;
}

export async function deletePublicationRequest(id: string) {
  await apiClient.delete(`/publication-request/${id}`);
}
